import Controller from '@ember/controller';

export default class SifLogsController extends Controller {
  queryParams = ['processMonitorId'];
  processMonitorId = '';
}
